<template>
  <apex-chart type="line" height="450" :series="series" :options="chartOptions" />
</template>

<script>
import ApexChart from 'vue-apexcharts'

export default {
  components: { ApexChart },

  props: {
    // c3 style columns from the api: [['x', ...weeks], [name, ...hours], ...]
    columns: { type: Array, default: () => [] }
  },

  computed: {
    weeks () {
      const [x = []] = this.columns

      return x.slice(1)
    },

    series () {
      return this.columns.slice(1).map(([name, ...data]) => ({ name, data }))
    },

    chartOptions () {
      return {
        chart: {
          toolbar: { show: false },
          zoom: { enabled: false },
          fontFamily: 'inherit'
        },
        stroke: { width: 2, curve: 'straight' },
        markers: { size: 3 },
        dataLabels: { enabled: false },
        legend: {
          position: 'right',
          fontSize: '12px'
        },
        xaxis: {
          categories: this.weeks,
          axisBorder: { show: false },
          axisTicks: { show: false },
          labels: { style: { colors: '#8b8fa7', fontSize: '12px' } }
        },
        yaxis: {
          title: { text: 'Weekly Hours', style: { color: '#8b8fa7', fontWeight: 500 } },
          labels: { style: { colors: '#a0a4b8', fontSize: '11px' } }
        },
        grid: {
          borderColor: '#f0f1f7',
          xaxis: { lines: { show: false } }
        },
        tooltip: {
          shared: true,
          intersect: false,
          theme: 'dark',
          y: { formatter: val => (val === null || val === undefined ? '-' : `${val} hrs`) }
        }
      }
    }
  }
}
</script>
